const list = {
  path: 'agentMessage',
  component: resolve => require(['@/pages/admin/platform/agentMessage'], resolve)
}

export default list
